import moment from 'moment';
import _ from 'lodash';
import {t} from 'shared/core';
import {groupKeyFor} from './eventGroups';

class CalendarEventViewModel {
  constructor(event) {
    this.key = event.id;
    this.title = event.title;
    this.allDay = !!event.allDay;
    this.type = _.get(event, 'extendedProps.type');
    this.start = moment(event.start);
    this.firstDay = this.start.clone().startOf('day');
    this.end = moment(event.end);
    this.subjectEmployee = event.subjectEmployee;
    this.groupKey = groupKeyFor(this.type);
  }

  get timeLabel() {
    return this.start.format(t('components.dates.TIMESTAMP_FORMAT'));
  }

  occursOn(date) {
    return date.isSameOrAfter(this.firstDay) && date.isBefore(this.end);
  }
}

export default CalendarEventViewModel;
